export const SHARED_TABLET_IDLE_TIMEOUT_MS = 2 * 60_000;

export function shouldLockSharedTabletOnBackground(input: {
  isSharedTablet: boolean;
  hasActiveOperator: boolean;
  externalActivityActive: boolean;
}): boolean {
  return input.isSharedTablet
    && input.hasActiveOperator
    && !input.externalActivityActive;
}
